module.exports = __webpack_public_path__ + "04_long_black.bde3fc7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/04_long_black.png
// module id = lstp
// module chunks = 0